import ToastMessage from 'src/components/ToastContainer';
import ProfileComponent from '../components/profile';
import SecurityComponent from '../components/security';
import BillingPlansComponent from '../components/billingPlans';
import { useSettingActions } from 'src/store/settings/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SettingMenu from '../components/settingMenu';
const AccountSetting = () => {
  const dispatch = useDispatch();
  const settingAction = useSettingActions(dispatch);
  const navigate = useNavigate();
  const { accountInfo } = useSelector((state: RootState) => {
    return {
      accountInfo: state.setting.accountInfo
    };
  });

  useEffect(() => {
    settingAction.getAccountInfoRequest();
    settingAction.getAccountPlansRequest({ pageNumber: 1 });
  }, []);
  return (
    <div>
      <ToastMessage />
      <div className="custom-theme">
        <div>
          <div>
            <SettingMenu />
            <div className="tab-content" id="tabs-tabContentVertical">
              <ProfileComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSetting;
